(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const pagina = document.getElementById('configuraciones');
        if (!pagina) return;

        const modales = Array.from(document.querySelectorAll('.configuracion-modal'));
        const estado = {};
        let botonApertura = null;

        const normalizar = (valor) => String(valor ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLocaleLowerCase('es');

        function nombreRegistro(tipo, registro) {
            const campos = {
                destino: 'nombre_destino',
                etapa: 'nombre_etapa',
                grupo_mercancia: 'grupo_mercancia',
                proveedor: 'nombre_proveedor',
                usuario: 'nombre',
            };
            return String(registro[campos[tipo]] || 'Registro');
        }

        function idRegistro(tipo, registro) {
            const campos = {
                destino: 'id_destino',
                etapa: 'id_etapa',
                grupo_mercancia: 'id_grupo',
                proveedor: 'id_proveedor',
                usuario: 'id_usuario',
            };
            return Number(registro[campos[tipo]] || 0);
        }

        function crearBotonAccion(accion, etiqueta, icono) {
            const boton = document.createElement('button');
            boton.type = 'button';
            boton.className = `btn-tabla config-accion config-accion-${accion}`;
            boton.dataset.action = accion;
            boton.setAttribute('aria-label', etiqueta);
            boton.title = etiqueta;

            const imagen = document.createElement('img');
            imagen.className = 'svg-acciones';
            imagen.src = `/public/build/img/icons/${icono}.svg`;
            imagen.alt = '';
            boton.appendChild(imagen);
            return boton;
        }

        function crearCelda(valor) {
            const celda = document.createElement('td');
            celda.textContent = valor == null || valor === '' ? '—' : String(valor);
            return celda;
        }

        function listaCorreos(valor) {
            return String(valor ?? '')
                .split(/[,;\r\n]+/)
                .map((correo) => correo.trim())
                .filter(Boolean);
        }

        function crearCeldaNotificacion(valor) {
            const correos = listaCorreos(valor);
            const celda = document.createElement('td');
            if (!correos.length) {
                celda.textContent = '—';
                return celda;
            }
            celda.textContent = correos.length === 1
                ? correos[0]
                : `${correos[0]} (+${correos.length - 1})`;
            celda.title = correos.join(', ');
            return celda;
        }

        function crearFila(modal, registro) {
            const tipo = modal.dataset.configType;
            const fila = document.createElement('tr');
            fila.dataset.id = String(idRegistro(tipo, registro));

            if (tipo === 'destino') {
                fila.append(crearCelda(registro.nombre_destino), crearCelda(registro.ciudad));
            } else if (tipo === 'etapa') {
                fila.append(crearCelda(registro.nombre_etapa));
            } else if (tipo === 'grupo_mercancia') {
                fila.append(crearCelda(registro.grupo_mercancia));
            } else if (tipo === 'proveedor') {
                fila.append(crearCelda(registro.nombre_proveedor));
            } else {
                fila.append(
                    crearCelda(registro.nombre),
                    crearCelda(registro.email),
                    crearCeldaNotificacion(registro.email_notification),
                    crearCelda(registro.rol)
                );
                const estadoCelda = document.createElement('td');
                const indicador = document.createElement('span');
                const activo = Number(registro.estado) === 1;
                indicador.className = `configuracion-estado configuracion-estado-${activo ? 'activo' : 'inactivo'}`;
                indicador.textContent = activo ? 'Activo' : 'Inactivo';
                estadoCelda.appendChild(indicador);
                fila.appendChild(estadoCelda);
            }

            const acciones = document.createElement('td');
            const contenedor = document.createElement('div');
            contenedor.className = 'cont-acciones';
            const botonEditar = crearBotonAccion('editar', `Editar ${nombreRegistro(tipo, registro)}`, 'editar');
            const botonEliminar = crearBotonAccion('eliminar', `Eliminar ${nombreRegistro(tipo, registro)}`, 'eliminar');
            if (tipo === 'usuario' && idRegistro(tipo, registro) === Number(pagina.dataset.currentUser)) {
                botonEliminar.disabled = true;
                botonEliminar.setAttribute('aria-label', 'No puedes eliminar tu propio usuario');
                botonEliminar.title = 'No puedes eliminar tu propio usuario';
            }
            contenedor.append(botonEditar, botonEliminar);
            acciones.appendChild(contenedor);
            fila.appendChild(acciones);
            return fila;
        }

        function filtrarModal(modal) {
            const consulta = normalizar(modal.querySelector('[data-config-search]').value.trim());
            const registros = estado[modal.dataset.configDataset] || [];
            const filtrados = consulta
                ? registros.filter((registro) => normalizar(Object.values(registro).join(' ')).includes(consulta))
                : registros;
            pintarTabla(modal, filtrados, consulta !== '');
        }

        function pintarTabla(modal, registros, esFiltro) {
            const cuerpo = modal.querySelector('[data-config-table-body]');
            cuerpo.replaceChildren();

            if (!registros.length) {
                const fila = document.createElement('tr');
                fila.className = 'no-data';
                const celda = document.createElement('td');
                celda.colSpan = modal.querySelectorAll('thead th').length;
                celda.textContent = esFiltro
                    ? 'No hay resultados para esta búsqueda.'
                    : 'Aún no hay registros. Crea el primero con “Nuevo registro”.';
                fila.appendChild(celda);
                cuerpo.appendChild(fila);
                return;
            }

            const fragmento = document.createDocumentFragment();
            registros.forEach((registro) => fragmento.appendChild(crearFila(modal, registro)));
            cuerpo.appendChild(fragmento);
        }

        function mostrarError(modal, mensaje) {
            const cuerpo = modal.querySelector('[data-config-table-body]');
            cuerpo.replaceChildren();
            const fila = document.createElement('tr');
            fila.className = 'no-data configuracion-error';
            const celda = document.createElement('td');
            celda.colSpan = modal.querySelectorAll('thead th').length;
            celda.textContent = mensaje;
            fila.appendChild(celda);
            cuerpo.appendChild(fila);
        }

        function actualizarContadores() {
            document.querySelectorAll('[data-config-count]').forEach((contador) => {
                const total = (estado[contador.dataset.configCount] || []).length;
                contador.textContent = String(total);
                contador.setAttribute('aria-label', `${total} registros`);
            });
        }

        async function cargarConfiguraciones() {
            try {
                const respuesta = await fetch('/api/configuraciones', {
                    credentials: 'include',
                    cache: 'no-store',
                    headers: { Accept: 'application/json' },
                });
                const cuerpo = await respuesta.json();
                if (respuesta.status === 401) {
                    window.location.assign('/login');
                    return;
                }
                if (!respuesta.ok || !cuerpo.success) {
                    const error = cuerpo.errors && cuerpo.errors[0];
                    throw new Error((error && error.message) || 'No fue posible cargar las configuraciones.');
                }

                Object.assign(estado, cuerpo.result || {});
                actualizarContadores();
                modales.forEach((modal) => filtrarModal(modal));
            } catch (error) {
                console.error('Error al cargar configuraciones:', error);
                modales.forEach((modal) => mostrarError(modal, error.message));
            }
        }

        function cambiarVista(modal, vista) {
            const listado = modal.querySelector('.configuracion-listado');
            const toolbar = modal.querySelector('.configuracion-toolbar');
            const editor = modal.querySelector('[data-config-editor]');
            const confirmacion = modal.querySelector('[data-config-confirm]');
            listado.hidden = vista !== 'listado';
            toolbar.hidden = vista !== 'listado';
            editor.hidden = vista !== 'editor';
            confirmacion.hidden = vista !== 'confirmacion';
        }

        function actualizarVisibilidad(formulario) {
            const rol = formulario.elements.id_rol;
            const campo = formulario.querySelector('[data-visibility-field]');
            if (!rol || !campo) return;
            const comercial = Number(rol.value) === 2;
            campo.hidden = !comercial;
            campo.querySelector('input').disabled = !comercial;
        }

        function abrirEditor(modal, registro = null) {
            const formulario = modal.querySelector('.configuracion-form');
            const tipo = modal.dataset.configType;
            formulario.reset();
            formulario.querySelectorAll('.imputRojo').forEach((campo) => campo.classList.remove('imputRojo'));
            formulario.elements.id.value = registro ? idRegistro(tipo, registro) : '';
            modal.querySelector('[data-config-form-title]').textContent = registro ? 'Editar registro' : 'Nuevo registro';

            if (tipo === 'usuario') {
                formulario.elements.nombre.value = registro ? registro.nombre : '';
                formulario.elements.email.value = registro ? registro.email : '';
                formulario.elements.email_notification.value = registro ? (registro.email_notification || '') : '';
                formulario.elements.id_rol.value = registro ? registro.id_rol : '';
                formulario.elements.id_permiso_visibilidad.value = registro ? registro.id_permiso_visibilidad : 0;
                formulario.elements.estado.value = registro ? registro.estado : 1;
                formulario.elements.password.value = '';
                formulario.elements.password.required = !registro;
                modal.querySelector('[data-password-required]').hidden = Boolean(registro);
                modal.querySelector('[data-password-help]').textContent = registro
                    ? 'Déjala vacía para conservar la contraseña actual.'
                    : 'Mínimo 8 caracteres.';
                actualizarVisibilidad(formulario);
            } else {
                formulario.elements.nombre.value = registro ? nombreRegistro(tipo, registro) : '';
                if (tipo === 'destino') formulario.elements.ciudad.value = registro ? (registro.ciudad || '') : '';
            }

            cambiarVista(modal, 'editor');
            window.setTimeout(() => formulario.querySelector('input:not([type="hidden"]), select').focus(), 0);
        }

        function abrirConfirmacion(modal, registro) {
            const formulario = modal.querySelector('.configuracion-eliminar-form');
            formulario.elements.id.value = idRegistro(modal.dataset.configType, registro);
            modal.querySelector('[data-config-delete-name]').textContent = nombreRegistro(modal.dataset.configType, registro);
            cambiarVista(modal, 'confirmacion');
            window.setTimeout(() => formulario.querySelector('[data-config-delete-cancel]').focus(), 0);
        }

        modales.forEach((modal) => {
            const busqueda = modal.querySelector('[data-config-search]');
            busqueda.addEventListener('input', () => filtrarModal(modal));
            modal.querySelector('[data-config-new]').addEventListener('click', () => abrirEditor(modal));
            modal.querySelectorAll('[data-config-cancel]').forEach((boton) => {
                boton.addEventListener('click', () => cambiarVista(modal, 'listado'));
            });
            modal.querySelector('[data-config-delete-cancel]').addEventListener('click', () => cambiarVista(modal, 'listado'));

            const rol = modal.querySelector('[name="id_rol"]');
            if (rol) rol.addEventListener('change', () => actualizarVisibilidad(modal.querySelector('.configuracion-form')));

            modal.querySelector('[data-config-table-body]').addEventListener('click', (evento) => {
                const boton = evento.target.closest('[data-action]');
                if (!boton) return;
                const fila = boton.closest('tr[data-id]');
                const registros = estado[modal.dataset.configDataset] || [];
                const registro = registros.find((item) => idRegistro(modal.dataset.configType, item) === Number(fila.dataset.id));
                if (!registro) return;
                if (boton.dataset.action === 'editar') abrirEditor(modal, registro);
                if (boton.dataset.action === 'eliminar') abrirConfirmacion(modal, registro);
            });
        });

        document.querySelectorAll('.configuracion-abrir').forEach((boton) => {
            boton.addEventListener('click', () => {
                botonApertura = boton;
                const modal = document.querySelector(boton.id);
                if (!modal) return;
                cambiarVista(modal, 'listado');
                modal.querySelector('[data-config-search]').value = '';
                filtrarModal(modal);
                window.setTimeout(() => modal.querySelector('[data-config-search]').focus(), 0);
            });
        });

        document.querySelectorAll('.configuracion-modal .cerrar_modal').forEach((boton) => {
            boton.addEventListener('click', () => {
                if (botonApertura) botonApertura.focus();
            });
        });

        window.addEventListener('spray:datos-actualizados', (evento) => {
            if (evento.detail && ['guardarConfiguracion', 'eliminarConfiguracion'].includes(evento.detail.action)) {
                cargarConfiguraciones();
            }
        });

        cargarConfiguraciones();
    });
})();
